export default __webpack_public_path__ + "static/media/tell-us-about-your-startup.4420f38d.svg";